
import FacilityDashboard from '@/components/FacilityDashboard';

export default function FacilityDashboardPage() {
  return <FacilityDashboard />;
}
